import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import './calendarStyle.css';

export default function Calendar({ onChange }) {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                views={['month', 'year']}
                onChange={(date) => onChange(new Date(date))}
                defaultValue={dayjs(new Date())}
                slotProps={{
                    textField: {
                        className: 'custom-datepicker',
                    },
                }}
            />
        </LocalizationProvider>
    );
}